import { ActionType, ProColumns } from '@ant-design/pro-components';
import { DatePicker, Form } from 'antd';
import BoxContainer from 'base/ui/components/BoxContainer';
import CustomButton from 'base/ui/components/Button';
import CustomSelect from 'base/ui/components/CustomSelect';
import CustomProTable from 'base/ui/components/CustomTable';
import { Filter } from 'base/ui/components/Icons';
import dayjs from 'dayjs';
import usePartialState from 'hooks/usePartialState';
import { observer } from 'mobx-react';
import PageWrapper from 'pages/Components/PageWrapper';
import { SearchBox, SearchForm, SearchItem } from 'pages/Components/SearchBox';
import { SearchModel } from 'pages/model';
import { useEffect, useRef, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { CommonModel } from 'services/Main/common_services';
import { commonPresenter, commonStore } from 'stores/root_store';
import { DATE_FORMAT_DEFAULT, DATE_FORMAT_POST } from 'utils/constants';
import * as Icon from 'base/ui/components/Icons';
import useDebounce from 'hooks/useDebounce';
import { dropdownstatus } from 'pages/Components/dataDropDown';


const { RangePicker } = DatePicker;

// BÁO CÁO THỐNG KÊ SỐ LIỆU LỊCH DVKT
const createStatisticsRevenueReport = () => {
  return observer(() => {
    //=====================================CHUYỂN NGÔN NGỮ=====================================//
    const { t } = useTranslation();
    const [form] = Form.useForm();

    const tableRef = useRef<ActionType>();
    const columns = [
      // Ngày
      {
        title: 'Ngày',
        dataIndex: 'date',
        key: 'date',
        width: 60,
        align: 'center',
      },
      // Tháng 1
      {
        title: 'Tháng 1',
        dataIndex: 'month1',
        key: 'month1',
        width: 80,
      },
      // Tháng 2
      {
        title: 'Tháng 2',
        dataIndex: 'month2',
        key: 'month2',
        width: 80,
      },
      // Tháng 3
      {
        title: 'Tháng 3',
        dataIndex: 'month3',
        key: 'month3',
        width: 80,
      },
      // Tháng 4
      {
        title: 'Tháng 4',
        dataIndex: 'month4',
        key: 'month4',
        width: 80,
      },
      // Tháng 5
      {
        title: 'Tháng 5',
        dataIndex: 'month5',
        key: 'month5',
        width: 80,
      },
      // Tháng 6
      {
        title: 'Tháng6',
        dataIndex: 'mont6',
        key: 'mont6',
        width: 80,
      },
      // Tháng 7
      {
        title: 'Tháng 7',
        dataIndex: 'month7',
        key: 'month7',
        width: 80,
      },
      // Tháng 8
      {
        title: 'Tháng 8',
        dataIndex: 'month8',
        key: 'month8',
        width: 80,
      },
      // Tháng 9
      {
        title: 'Tháng 9',
        dataIndex: 'month9',
        key: 'month9',
        width: 80,
      },
      // Tháng 10
      {
        title: 'Tháng 10',
        dataIndex: 'month10',
        key: 'month10',
        width: 80,
      },
      // Tháng 11
      {
        title: 'Tháng 11',
        dataIndex: 'month11',
        key: 'month11',
        width: 80,
      },
      // Tháng 12
      {
        title: 'Tháng 12',
        dataIndex: 'month12',
        key: 'month12',
        width: 80,
      },


    ] as ProColumns[]

    //----------------------------------------- DATA TABLE ------------------------------------------
    const [dataSearch, setDataSearch] = useState<SearchModel>({
      companyCode: "1000",
    });


    // data common date
    const [listCommonDate, setListCommonDate] = useState<CommonModel[]>([]);
    // disable rangePicker khi chọn ngày từ common
    const [disableRangePicker, setDisableRangePicker] = useState(false);

    const [loading, setLoading] = usePartialState({
      loadingSearch: false,
      loading: false,
    })


    const [open, setOpen] = usePartialState({
      openDrawer: false,
      openModal: false,
      openConfirm: false,
    });

    // Công ty
    const [listCompany, setListCompany] = useState<CommonModel[]>([]);
    // bảo hành
    const [listWarranty, setListWarranty] = useState<CommonModel[]>([]);
    // Phòng ban
    const [listDepartment, setListDepartment] = useState<CommonModel[]>([]);
    // nhân viên
    const [listCreateBy, setListCreateBy] = useState<CommonModel[]>([]);



    // -------------------------------------------------------------------------------------------------
    // -------------------------------------------------------------------------------------------------
    // -------------------------------------------------------------------------------------------------
    // show filter form
    const showDrawer = () => {
      setOpen({ ...open, openDrawer: true });
    };
    // close filter form
    const onClose = () => {
      setOpen({ ...open, openDrawer: false });
    };

    // Công ty
    const getDataCompany = async () => {
      await commonPresenter.getCompanyByAccount(commonStore);
      if (commonStore.commonRespone.isSuccess) {
        setListCompany(commonStore.commonRespone.data);
      }
    };

    // Lấy danh sách người tạo
    const getListCreateBy = async (key = '') => {
      await commonPresenter.getListPersonInCharge(commonStore, key);
      if (commonStore.commonRespone.isSuccess) {
        setListCreateBy(commonStore.commonRespone.data);
      }
    };
    const searchCreateBy = useDebounce(getListCreateBy, 500);

    // Phòng ban
    const getDataDepartment = async (key?: string) => {
      await commonPresenter.getListDepartment(commonStore, key);
      if (commonStore.commonRespone.isSuccess) {
        setListDepartment(commonStore.commonRespone.data);
      }
    };

    const getDropdownWarranty = async (key = '') => {
      await commonPresenter.getCommonDataByKey(commonStore, "ServiceTechnicalTeam");
      if (commonStore.commonRespone.isSuccess) {
        setListWarranty(commonStore.commonRespone.data)
      }
    }
    const debounceSearchWarranty = useDebounce(getDropdownWarranty, 300);


    // Lấy ngày bằng common data
    const getDateByKey = async (key: string) => {
      setLoading({ loadingSearch: true })
      await commonPresenter.getDateByCommonDate(commonStore, key);
      if (commonStore.commonDate.fromDate) {

        // set value ban đầu chp biến để search báo cáo (ngày tháng)
        setDataSearch({
          ...dataSearch,
          fromDate: commonStore.commonDate.fromDate ? dayjs(commonStore.commonDate.fromDate)?.format(DATE_FORMAT_POST) : undefined,
          toDate: commonStore.commonDate.toDate ? dayjs(commonStore.commonDate.toDate)?.format(DATE_FORMAT_POST) : undefined,
          companyId: form.getFieldValue('companyId')
        });


        form.setFieldValue("ngayDanhGia", [
          dayjs(commonStore.commonDate.fromDate),
          dayjs(commonStore.commonDate.toDate),
        ]);
      } else {
        form.setFieldValue("ngayDanhGia", undefined);
      }
      setLoading({ loadingSearch: false })
    };

    // Lấy danh sách common date
    const getListCommonDate = async () => {
      setLoading({ loadingSearch: true })
      await commonPresenter.getListSelectCommonDate(commonStore);
      if (commonStore.commonRespone.isSuccess) {
        setListCommonDate(commonStore.commonRespone.data);
      }
      setLoading({ loadingSearch: false })
    };
    //================================================================================================
    //================================================================================================
    //================================================================================================
    useEffect(() => {
      (async () => {
        getDataCompany()
        debounceSearchWarranty()
        getDataDepartment()
        getListCommonDate()
        searchCreateBy()
      })()
    }, [])

    return (
      <PageWrapper
        breadcrumb={[
          {
            text: t('page-title.report-statistics-revenue'),
          },
        ]}
        extras={
          <>
            {/* {checkPermission('CREATE') && (
              <div></div>
            )} */}
            <CustomButton onClick={showDrawer} type="primary" color="#EFF4F9" className="!px-0 w-8">
              <Filter className="!fill-primary" />
            </CustomButton>
          </>
        }
      >
        <BoxContainer>
          <CustomProTable
            bordered
            columns={columns}
            dataSource={[]}
            rowKey={'stt'}
            actionRef={tableRef}
            // request={async (params = {}, sort, filter) => {
            //   let data: WarrantyActiveReportModel[] = [];
            //   data = await getDataReport(dataSearch);

            //   return {
            //     data: data,
            //     success: reportVisitCustomerSRStore.reportWarrantyActive.isSuccess,
            //   };
            // }}

            toolBarRender={() => [
              // EXPORT =================================================================
              <CustomButton
                loading={loading.loading}
                onClick={async () => {
                  setLoading({ loading: true });
                  const { paging, ...rest } = dataSearch
                  // await reportVisitCustomerSRPresenter.exportExcelCustomerSurvey({ ...rest, lang: uiStore.language })
                  setLoading({ loading: false });
                }}
                icon={<Icon.Download className={'!fill-dark'} />}
              >
                {t('btn.export')}
              </CustomButton>]}

            options={false}
          />
        </BoxContainer>

        {/* Form search */}
        <SearchBox
          onClose={onClose}
          className="lg:!w-[25%]"
          open={open.openDrawer}
          footer={
            <CustomButton
              htmlType="submit"
              className="my-auto ml-auto"
              loading={loading.loadingSearch}
              type="primary"
              onClick={() => {
                setDataSearch({
                  ...form.getFieldsValue(),
                });
                form.submit();
                tableRef.current?.reload();
                onClose();
              }}
            >
              {t('btn.search')}
            </CustomButton>
          }
        >
          <SearchForm
            form={form}
            onFinish={(value) => {
              tableRef.current?.reload();
            }}
            column="col-1"
            initialValues={{
              companyCode: '1000'
            }}
          >
            {/* Công ty */}
            <SearchItem col2
              rules={[{ required: true }]}
              name={"companyCode"}
              label={"Công ty"}
            >
              <CustomSelect
                allowClear
                options={listCompany}
                fieldNames={{ label: "value", value: "key" }}
                showSearch
                filterOption={(input, option) =>
                  (option?.value ?? "")
                    .toLowerCase()
                    .includes(input.toLowerCase())
                }
              />
            </SearchItem>

            <SearchItem col2
              name={"warrantyCode"}
              label={"Bảo hành"}
            >
              <CustomSelect
                allowClear
                showSearch
                mode="multiple"
                filterOption={false}
                fieldNames={{ label: "value", value: "key" }}
                onBlur={async () => await debounceSearchWarranty()}
                options={listWarranty}
                onClear={() => debounceSearchWarranty()}
                onSearch={(value) => {
                  value ? debounceSearchWarranty(value) : debounceSearchWarranty()
                }}
              />
            </SearchItem>

            {/* Phòng ban */}
            <SearchItem
              name={"department"}
              label={t("search-form.department")}
              col2
            >
              <CustomSelect
                options={listDepartment}
                fieldNames={{ label: "value", value: "key" }}
                filterOption={(input, option) =>
                  (option?.value ?? "")
                    .toLowerCase()
                    .includes(input.toLowerCase())
                }
                allowClear
                showSearch
              />
            </SearchItem>

            {/* Nhân viên được phân công */}
            <SearchItem name={'employee'} label={'Nhân viên được phân công'} col2>
              <CustomSelect
                options={listCreateBy}
                mode='multiple'
                fieldNames={{ label: 'value', value: 'key' }}
                filterOption={false}
                onSearch={(value) => {
                  searchCreateBy(value);
                }}
                allowClear
                showSearch
              />
            </SearchItem>
            {/* Thời gian  */}
            <SearchItem name={"commonDate"} label={"Thời gian"} start col2>
              <CustomSelect
                options={listCommonDate}
                fieldNames={{ label: "value", value: "key" }}
                onChange={async (value, option) => {
                  if (option) {
                    setDisableRangePicker(
                      option.key === "Custom" ? false : true
                    );
                    await getDateByKey(option.key);
                  } else {
                    setDisableRangePicker(false);
                    form.setFieldValue("ngayDanhGia", undefined);
                  }
                }}
                allowClear
              />
            </SearchItem>
            {/* chọn ngày*/}
            <SearchItem name={"ngayDanhGia"} col2>
              <RangePicker
                disabled={disableRangePicker}
                format="DD/MM/YYYY"
                className="w-full"
              />
            </SearchItem>

            {/* Trạng thái */}
            <SearchItem name={'active'} col2 label={t('segment.trang-thai')}>
              <CustomSelect className='!w-full' options={dropdownstatus} allowClear />
            </SearchItem>
          </SearchForm>
        </SearchBox >
      </PageWrapper>
    )
  })
}

export default createStatisticsRevenueReport